import axios from 'axios';

export default function() {
  return {
    namespaced: true,
    state: {
      menu: {},
    },
    mutations: {
      SET_MENU(state, { data, locale }) {
        // TODO: data validation
        state.menu = {
          ...state.menu,
          [locale]: data,
        }
        // state.menu[locale] = data;
      },
    },
    actions: {
      FETCH_MENU({ state, commit }, { locale }) {
        if (state.menu[locale]) return;

        return axios.get(encodeURI(`/api/experience/menu`))
          .then((res) => {
            const data = res.data || [];
            
            // data.forEach(({topViewSight}, idx) => {
            //   if (!Array.isArray(topViewSight)) return ;
            //   let topIdx = Math.floor(Math.random() * topViewSight.length);
            //   data[idx].topViewSight = {...topViewSight[topIdx]};
            // })

            commit('SET_MENU', { data, locale });
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getMenu: (state) => (locale) => {
        return state.menu[locale] || [];
      },
      getCategoryName: (state) => (locale, category) => {
        let menu = state.menu[locale] || [];
        let categoryIdx = menu.findIndex((c) => c.category == category);

        return categoryIdx == -1 ? "" : menu[categoryIdx].name;
      }
    }
  }
}